import { ContentService } from '@blk/cwp-ng-framework';
import { chain } from 'lodash';

import { CellData } from '../cell-data';
import { ColumnConfig } from '../column-config';
import { ColumnText } from '../column-text';
import { StoreColumnExtractor } from '../extractors/store-column-extractor';
import { TableData } from '../table-data';
import { AsIsTableDataTransform } from '../table-data-transform/as-is-table-data-transform';
import { TableDataTransform } from '../table-data-transform/table-data-transform';
import { ExtractorConfig } from './extractor-config';

export class SimplePortfolioExtractorConfig extends ExtractorConfig {
	constructor(
		public firstColumnTitle: ColumnText,
		public readonly columns: ColumnConfig<StoreColumnExtractor>[] | Function,
		portfolioName: ColumnConfig<StoreColumnExtractor>,
		TableDataTransform: TableDataTransform = AsIsTableDataTransform.instance
	) {
		super(portfolioName, TableDataTransform);
	}

	public storeDependencies(): string[] {
		return chain(this.getColumns())
			.map((column: ColumnConfig<StoreColumnExtractor>) => column.extractor.storeConfigDependencies())
			.concat(this.portfolioName.extractor.storeConfigDependencies())
			.flattenDeep()
			.uniq()
			.value();
	}

	public extract(storeLookup: Map<string, any[]>, contentSvc: ContentService): TableData[] {
		const columns = this.getColumns();
		const portfolioColumnData = columns.map(column => this.extractStoreColumn(column, storeLookup, contentSvc));
		const cells: CellData[][] = chain(portfolioColumnData)
			.unzip()
			.map(portfolioCells => portfolioCells)
			.value();

		const portfolioNames: CellData[] = this.extractStoreColumn(this.portfolioName, storeLookup, contentSvc);
		const columnNames: CellData[] = this.generateColumnHeaders(columns, contentSvc);

		const tableData = new TableData(columnNames, portfolioNames, cells, portfolioNames, this.translateColumnText(this.firstColumnTitle, contentSvc));
		const transformedCells: TableData = this.tableDataTransform.transform(tableData, contentSvc);

		return [transformedCells];
	}

	/**
	 * Method to get the columns. This supports columns as Function type (e.g. needed when the columns depend on ConfigService)
	 * @returns columns extractors array
	 */
	private getColumns(): ColumnConfig<StoreColumnExtractor>[] {
		if (typeof this.columns === 'function') {
			return this.columns();
		} else {
			return this.columns;
		}
	}
}
